var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconamoonProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2253_3592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 20.25C1 18.7913 1.57946 17.3924 2.61091 16.3609C3.64236 15.3295 5.04131 14.75 6.5 14.75H17.5C18.9587 14.75 20.3576 15.3295 21.3891 16.3609C22.4205 17.3924 23 18.7913 23 20.25C23 20.9793 22.7103 21.6788 22.1945 22.1945C21.6788 22.7103 20.9793 23 20.25 23H3.75C3.02065 23 2.32118 22.7103 1.80546 22.1945C1.28973 21.6788 1 20.9793 1 20.25Z",
    stroke: "#616161",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25C14.2782 9.25 16.125 7.40317 16.125 5.125C16.125 2.84683 14.2782 1 12 1C9.72183 1 7.875 2.84683 7.875 5.125C7.875 7.40317 9.72183 9.25 12 9.25Z",
    stroke: "#616161",
    strokeOpacity: 0.7,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_3592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonProfile);
export default __webpack_public_path__ + "static/media/iconamoon_profile.c743ec7deee6bbda32daadbc9760a786.svg";
export { ForwardRef as ReactComponent };